import { render, staticRenderFns } from "./MetaplexMenu.vue?vue&type=template&id=28f80a61&scoped=true&"
import script from "./MetaplexMenu.vue?vue&type=script&lang=js&"
export * from "./MetaplexMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f80a61",
  null
  
)

export default component.exports